import ReactGA from "react-ga4";

type GaClient = { initialize(id: string, options: { gtagOptions: { send_page_view: false } }): void; event(name: string, parameters: Record<string, unknown>): void };

export function createProductGa4Reporter({
  measurementId,
  ga = ReactGA as unknown as GaClient,
}: { measurementId: string; ga?: GaClient }) {
  let initialized = false;
  return (event: string, parameters: Record<string, unknown>) => {
    if (!/^G-[A-Z0-9]{4,}$/.test(measurementId)
      || !["product_landing", "login_started", "login_failed"].includes(event)
      || parameters.consentState !== "granted") return;
    if (!initialized) {
      ga.initialize(measurementId, { gtagOptions: { send_page_view: false } });
      initialized = true;
    }
    ga.event(event, parameters);
  };
}
